import { render, staticRenderFns } from "./previewRp.vue?vue&type=template&id=497eab5e&scoped=true&"
import script from "./previewRp.vue?vue&type=script&lang=js&"
export * from "./previewRp.vue?vue&type=script&lang=js&"
import style0 from "./previewRp.vue?vue&type=style&index=0&id=497eab5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497eab5e",
  null
  
)

export default component.exports